import { ActivatedRoute, Router } from '@angular/router';

export type QueryParams = Record<string, string | number | null | undefined>;
export type QueryParamsHandling = 'merge' | 'preserve';

export function upsertQueryParams(
  router: Router,
  route: ActivatedRoute,
  params: QueryParams,
  handling: QueryParamsHandling = 'merge',
): void {
  router.navigate([], {
    relativeTo: route,
    queryParamsHandling: handling,
    queryParams: params,
  });
}
